import axios from 'axios'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Content Service for fetching Umbraco content
export class ContentService {
  
  /**
   * Fetch homepage content
   * @param {string} culture - Language culture (e.g., 'en-us', 'nl-nl')
   * @returns {Promise<Object>} Homepage content
   */
  static async getHomepage(culture = 'en-us') {
    try {
      console.log('[ContentService] Fetching homepage for culture:', culture)
      const response = await api.get('/content/homepage', {
        params: { culture }
      })
      console.log('[ContentService] Homepage response:', response.data)
      return response.data
    } catch (error) {
      console.error('[ContentService] Error fetching homepage content:', error)
      console.error('[ContentService] Error details:', error.response || error.message)
      
      return {
        heroTitle: '',
        heroSubtitle: '',
        heroDescription: '',
        heroBackgroundImage: '',
        heroBackgroundVideo: '',
        steamUrl: '',
        heroSecondaryButtonUrl: '',
        heroSecondaryButtonText: '',
        heroFeatures: [],
        gameElements: [],
        socialLinks: { title: '', links: [] }
      }
    }
  }

  /**
   * Fetch navigation menu items
   * @param {string} culture - Language culture
   * @returns {Promise<Array>} Navigation items
   */
  static async getNavigation(culture = 'en-us') {
    try {
      const response = await api.get('/content/navigation', {
        params: { culture }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching navigation:', error)
      throw error
    }
  }

  /**
   * Parse Umbraco block list navigation items
   * @param {Array} blockListData - Raw block list data from Umbraco
   * @returns {Array} Parsed navigation items
   */
  static parseNavigationItems(blockListData) {
    if (!blockListData || !Array.isArray(blockListData)) {
      return []
    }

    return blockListData.map(item => {
      const navigationItem = {
        title: item.title || '',
        url: item.url || '',
        dropdownItems: []
      }

      // Parse dropdown items from JSON string
      if (item.dropdownItems) {
        try {
          const dropdownData = typeof item.dropdownItems === 'string' 
            ? JSON.parse(item.dropdownItems) 
            : item.dropdownItems

          if (Array.isArray(dropdownData)) {
            navigationItem.dropdownItems = dropdownData.map(dropdown => ({
              title: dropdown.title || '',
              url: dropdown.url || ''
            }))
          }
        } catch (error) {
          console.warn('Error parsing dropdown items:', error)
        }
      }

      return navigationItem
    })
  }

  /**
   * Get media URL from Umbraco media item
   * @param {Object} mediaItem - Umbraco media item
   * @returns {string} Media URL
   */
  static getMediaUrl(mediaItem) {
    if (!mediaItem) return ''
    
    if (typeof mediaItem === 'string') return mediaItem
    
    if (mediaItem.url) return mediaItem.url
    
    if (mediaItem.mediaUrl) return mediaItem.mediaUrl
    
    return ''
  }
}

// Export axios instance for direct use if needed
export { api }
